import React from 'react';
import ErrorContainer from './containers';
import { useTranslation } from 'react-i18next';

const Offline = () => {
  const { t } = useTranslation();
  return <ErrorContainer message={t('errors.offline')} />;
};

export default Offline;
